import {makeStyles} from 'tss-react/mui';
import {Black} from 'wobi-web-common/dist/config/colors.config';

export default makeStyles()((theme) => ({
  paper: {
    width: 580,
    display: 'flex',
    maxHeight: 'calc(100% - 64px)',
    flexDirection: 'column',
    margin: 32,
    position: 'relative',
    overflowY: 'auto',
    outline: 'none',
    minHeight: '100px',
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      margin: 16,
    },
  },
  title: {
    color: theme.palette.secondary.dark,
    margin: '10px 0',
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 700,
    textAlign: 'center',
  },
  subtitle: {
    color: theme.palette.secondary.dark,
    margin: '10px 0 24px',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 400,
    textAlign: 'center',
    lineHeight: 1.6,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalHeader: {
    height: 20,
  },
  modalBody: {
    padding: '30px 40px 40px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 30px',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
  },
  confirmButton: {
    minWidth: 180,
    height: 48,
    borderRadius: 24,
    fontWeight: 700,
    fontSize: 16,
  },
  buttonDismiss: {
    display: 'inline-block',
    position: 'absolute',
    right: 32,
    top: 32,
    height: 14,
    width: 14,
    cursor: 'pointer',
    [theme.breakpoints.down('lg')]: {
      right: 22,
      top: 32,
    },
    '&:before, &:after': {
      position: 'relative',
      content: '""',
      display: 'block',
      width: 25,
      border: `1px solid ${Black[170]}`,
      [theme.breakpoints.down('lg')]: {
        width: 17,
      },
    },
    '&:before': {
      top: 6,
      left: -1,
      transform: 'rotate(45deg)',
    },
    '&:after': {
      top: 4,
      left: -1,
      transform: 'rotate(-45deg)',
    },
  },
}));
